const channels = new Map()

export function messageChannelEmit(eventName) {
  const channel = channels.get(eventName)
  channel.port1.postMessage(null)
}

export function messageChannelOn(onEventName, cb) {
  if (!channels.has(onEventName)) {
    channels.set(onEventName, new MessageChannel())
  }
  const channel = channels.get(onEventName)
  channel.port2.onmessage = function(event) {
    cb(event.data)
  }
}
